import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
// import * as crypto from 'crypto-browserify'
// import * as jwt from "jsonwebtoken";
import { Router } from "@angular/router";
import * as CryptoJS from 'crypto-js';
import { KJUR } from 'jsrsasign';

declare var Buffer: any;

@Injectable()
export class CommonService {
  private localKeys = {
    "language": "language",
    "gender": "gender",
    "chatInfo": "chatInfo",
    "countries": "countries",
    "packages": "packages",
    "dateFormat": "dateFormat"
  };
  whiteLabelImage: any;
  configData: any;
  ngt18Url = environment.API_URL + 'main/';
  modules: { module: string; right: string; path: string; }[];
  
  private refreshActivitiesSource = new Subject<void>();
  refreshActivities$ = this.refreshActivitiesSource.asObservable();

  triggerActivitiesRefresh() {
    this.refreshActivitiesSource.next();
  }

  constructor(private httpClient: HttpClient, private router: Router) {
    this.modules = [{ "module": "invoice", "right": "ngtMInv", "path": "/invoice/dashboard" },
    { "module": "vmisystem", "right": "ngtMVmi", "path": "/vmisystem/vmi" }, { "module": "contract", "right": "ngtMCon", "path": "/contract/dashboard" }, { "module": "edi", "right": "ngtMEdi", "path": "/edi/purchase/overview" },
    { "module": "analytics", "right": "ngtMAna", "path": "/analytics" }, { "module": "filemanager", "right": "ngtMFile", "path": "/filemanager" }, { "module": "dash", "right": "ngtMDash", "path": "/dash/dashboard" }, { "module": "purchase", "right": "ngtMPur", "path": "/purchase/overview" }];
  }
  getCurrentLanguageCode() {
    let currentLang = localStorage.getEncryptedItem("current_lang");
    let lang = 'de';
    if (currentLang) {
      currentLang = JSON.parse(currentLang);
      lang = currentLang["key"];
    }
    return lang;
  }
  fetchLanguage(language) {
    let langData = this.getCommonDataOnLanuguage(language, this.localKeys.language);
    if (!langData || this.getCurrentLanguageCode() != language) {
      var formData = new FormData();
      formData.append('userId', '');
      formData.append("loggedInTime", '');
      formData.append("lastRequestTime", '');
      return this.httpClient.post(this.ngt18Url + "core.standard.language&language=" + language, formData).pipe(map((res: Response) => {
        if (!res.status && res["isUnauthenticated"]) {
          this.logout();
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime", res["RESPONSETIME"]);
        if (res["STATUS"]) {
          this.setCommonDataOnLanguage(language, this.localKeys.language, res["DATA"]);
        }
        return res["DATA"];

      }));
    } else {
      return new Observable((observable) => {
        observable.next(langData);
        observable.complete();
      });
    }
  }

  fetchGender(language) {
    let genderData = this.getCommonDataOnLanuguage(language, this.localKeys.gender);
    if (!genderData) {
      var formData = new FormData();
      formData.append('userId', localStorage.getEncryptedItem('loginId'));
      formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
      formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
      return this.httpClient.post(this.ngt18Url + "core.standard.gender&language=" + language, formData).pipe(map((res: any) => {
        // let res = this.filterPipe.transform(response);
        if (!res.status && res["isUnauthenticated"]) {
          this.logout();
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime", res["RESPONSETIME"]);
        if (res["STATUS"]) {
          this.setCommonDataOnLanguage(language, this.localKeys.gender, res["DATA"]);
        }
        return res["DATA"];
      }));
    } else {
      return new Observable((observable) => {
        observable.next(genderData);
        observable.complete();
      });
    }
  }

  getCommonDataOnLanuguage(language, key) {
    let commonData = localStorage.getEncryptedItem("common-data");
    let retData = null;
    if (commonData) {
      try {
        commonData = JSON.parse(commonData);
        let commonLangData = commonData[language];
        if (commonLangData && commonLangData[key]) {
          retData = commonLangData[key];
        }
      } catch (e) {
        retData = null;
        throw "Error in parsing commondata from localStorage";
      } finally { }
    }
    return retData;
  }
  setCommonDataOnLanguage(language, key, data) {
    let commonData: any = localStorage.getEncryptedItem("common-data");
    let langData;
    if (commonData) {
      commonData = JSON.parse(commonData);
      commonData[language] = commonData[language] || {};
      langData = commonData[language];
    } else {
      commonData = {};
      commonData[language] = {};
      langData = commonData[language];
    }
    langData[key] = data;
    localStorage.setEncryptedItem("common-data", JSON.stringify(commonData));
  }
  getLanguageFromLangId(id) {
    let lanId = this.getCurrentLanguageCode();
    let languages = this.getCommonDataOnLanuguage(lanId, this.localKeys.language);
    for (let i = 0; i < languages.LANGUAGES.length; i++) {
      if (languages.LANGUAGES[i].CODE == id) {
        return languages.LANGUAGES[i].NAME;
      }
    }
  }
  encrypt(data: string): string {
    // if(data) {
    const key = CryptoJS.enc.Base64.parse(JSON.parse(atob(localStorage.getItem('bWV0YURhdGFDb25maWc='))).encryptionKey);

    const encrypted = CryptoJS.AES.encrypt(data, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString(); // Base64 encoded

    // }
    // else
    //   return data;
  }

  decrypt(ciphertextBase64: string): string {

    if (!localStorage.getItem('bWV0YURhdGFDb25maWc=')) {
      this.logout();
    }
    // if(ciphertextBase64) {
    const key = CryptoJS.enc.Base64.parse(JSON.parse(atob(localStorage.getItem('bWV0YURhdGFDb25maWc='))).encryptionKey);

    const decrypted = CryptoJS.AES.decrypt(ciphertextBase64, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
    // }
    //   else
    //     return ciphertextBase64;
  }

  // encrypt(data) {

  //   var binaryEncryptionKey = new Buffer( JSON.parse(atob( localStorage.getItem('bWV0YURhdGFDb25maWc='))).encryptionKey, "base64" );
  //   var binaryIV = new Buffer(0);

  //   var cipher = crypto.createCipheriv("AES-128-ECB", binaryEncryptionKey, binaryIV);
  //   var encryptedInput = (
  //     cipher.update(data, "utf8", "base64") +
  //     cipher.final("base64")
  //   );
  //   return encryptedInput;
  // }
  // decrypt(data) {

  //   try {


  //     var binaryEncryptionKey = new Buffer( JSON.parse(atob( localStorage.getItem('bWV0YURhdGFDb25maWc='))).encryptionKey, "base64" );
  //     var binaryIV = new Buffer(0);

  //     var decipher = crypto.createDecipheriv("AES-128-ECB", binaryEncryptionKey, binaryIV);
  //     var decryptedInput = (
  //       decipher.update(data, "base64", "utf8") +
  //       decipher.final("utf8")
  //     );
  //     return decryptedInput;
  //   } catch (error) {

  //     return '';
  //   }
  // }

  /**
   * Safely parse JSON and return null on invalid input instead of throwing.
   */
  safeJsonParse<T = any>(value: string): T | null {
    if (!value) return null;
    try {
      return JSON.parse(value) as T;
    } catch (e) {
      console.warn('CommonService.safeJsonParse: invalid JSON', e);
      return null;
    }
  }

  createObject(data) {
    var object = {};

    if (!Array.prototype.forEach) {
      Array.prototype.forEach = function (fn, scope) {
        for (var i = 0, len = this.length; i < len; ++i) {
          fn.call(scope, this[i], i, this);
        }
      };
    }
    data.forEach(function (value, key) {
      object[key] = value;
    });
    object['instanceId'] = localStorage.getEncryptedItem('instanceId');
    object['loginCompanyId'] = localStorage.getEncryptedItem('companyId');
    object['userNumber'] = localStorage.getEncryptedItem("userNumber");

    return object;
  }
  createToken(data: any): string {
    let privateKeyPem;
    let privateKey = JSON.parse(atob(localStorage.getItem('bWV0YURhdGFDb25maWc='))).privateKey.key;
    let key = '';
    let begin = '-----BEGIN RSA PRIVATE KEY-----';
    let end = '-----END RSA PRIVATE KEY-----';
    while (privateKey.length > 0) {
      key += privateKey.substring(0, 64) + '\n';
      privateKey = privateKey.substring(64);
    }
    privateKeyPem = `${begin}\n${key}${end}\n`;
    const header = { alg: 'RS256', typ: 'JWT' };
    const payload = {
      ...data,
      exp: Math.floor(Date.now() / 1000) + 120
    };

    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(payload);

    const token = KJUR.jws.JWS.sign('RS256', sHeader, sPayload, privateKeyPem);

    return token;
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  setCookie(name: string, value: any, expireDays: number, domain: string, path: string = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    domain = domain || localStorage.getEncryptedItem('domain') || environment.SUB_DOMAIN;
    // document.cookie = `${name}=${value};domain=${localStorage.getEncryptedItem('domain')}; ${expires}${cpath};`;
    document.cookie = `${name}=${value}; domain=${domain}; ${expires}${cpath};`;
  }

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {
      type: contentType
    });
    return blob;
  };


  logout() {
     console.trace("myFunction called from");
    
    let instance = localStorage.getEncryptedItem('instance');
    let config = localStorage.getItem('bWV0YURhdGFDb25maWc=');
    localStorage.clear();
    localStorage.setItem('bWV0YURhdGFDb25maWc=', config);
    setTimeout(() => {
      console.log("commonser")
      // instance ?  window.location.href = 'http://'+instance+environment.logout_url+'/'+encodeURIComponent(this.encrypt(window.location.href)): this.router.navigate(['/unauthorized']);
      instance ? window.location.href = 'https://' + instance + environment.logout_url + '/' + encodeURIComponent(this.encrypt(window.location.href)) : this.router.navigate(['/unauthorized']);
    }, 10);

  }

  fetchCountryList(language) {
    let countryList = this.getCommonDataOnLanuguage(language, this.localKeys.countries);
    if (!countryList) {
      var formData = new FormData();
      formData.append('userId', localStorage.getEncryptedItem('loginId'));
      formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
      formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
      return this.httpClient.post(this.ngt18Url + "core.standard.country&language=" + language, formData).pipe(map((res: any) => {
        // res = res.json();
        if (!res.status && res["isUnauthenticated"]) {
          this.logout();
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime", res["RESPONSETIME"]);
        if (res["STATUS"]) {
          this.setCommonDataOnLanguage(language, this.localKeys.countries, res["DATA"]);
        }
        return res["DATA"];
      }));
    } else {
      return new Observable((observable) => {
        observable.next(countryList);
        observable.complete();
      });
    }
  }

  clearCookieStorage() {
    let cookies = document.cookie.split("; ");
    for (let c = 0; c < cookies.length; c++) {
      let d = window.location.hostname.split(".");
      while (d.length > 0) {
        let cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        let p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        };
        d.shift();
      }
    }
  }
  getCountryFromCode(id) {
    let lanId = this.getCurrentLanguageCode();
    let country = this.getCommonDataOnLanuguage(lanId, this.localKeys.countries);
    for (let i = 0; i < country.COUNTRIES.length; i++) {
      if (country.COUNTRIES[i].CODE == id) {
        return country.COUNTRIES[i].NAME;
      }
    }
  }

  getGenderFromCode(id) {
    let lanId = this.getCurrentLanguageCode();
    let gender = this.getCommonDataOnLanuguage(lanId, this.localKeys.gender);
    for (let i = 0; i < gender.GENDER.length; i++) {
      if (gender.GENDER[i].CODE == id) {
        return gender.GENDER[i].NAME;
      }
    }
  }

  createFormDataToken(formData: FormData) {
    const object = this.createObject(formData);
    const token = this.createToken(object);
    const encryptedToken = this.encrypt(token);
    const encrData = new FormData();
    encrData.append("encrToken", encryptedToken);
    return encrData;
  }
}

